import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core'

import { filter, map, takeUntil, tap } from 'rxjs'

import { DestroyDirective } from '~/core/directives'
import { CompanyFacade } from '~/core/features'
import { ForecastHistoricalChartComponent } from '~/ui/forecast-historical-chart'
import { LoadingComponent } from '~/ui/loading'

@Component({
  selector: 'app-historical-data-container',
  template: `
    @defer (on immediate) {
      <app-forecast-historical-chart></app-forecast-historical-chart>
    } @loading {
      <app-loading class="loading"></app-loading>
    }
  `,
  styleUrl: './historical-data-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [DestroyDirective],
  imports: [LoadingComponent, ForecastHistoricalChartComponent],
})
export class HistoricalDataContainerComponent implements OnInit {
  private readonly destroy$ = inject(DestroyDirective).destroy$

  readonly companyFacade = inject(CompanyFacade)

  constructor() {}

  ngOnInit(): void {
    this.companyFacade.forecast$
      .pipe(
        filter(forecast => Boolean(forecast)),
        map(forecast => forecast!.company.companyId),
        tap(companyId => {
          this.companyFacade.getContourData(companyId)
          this.companyFacade.getImpactIsolines(companyId)
        }),
        takeUntil(this.destroy$)
      )
      .subscribe()
  }
}
